var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountByWorkplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.656,
    height: 89.355,
    viewBox: "0 0 65.656 89.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    transform: "translate(-1152.465 -530)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232",
    transform: "translate(1152.465 530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M3.213,0H26.506a3.11,3.11,0,0,1,3.213,3V37.449a3.11,3.11,0,0,1-3.213,3H3.213a3.11,3.11,0,0,1-3.213-3V3A3.11,3.11,0,0,1,3.213,0Z",
    transform: "translate(0 0)",
    fill: "#2c3d71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130",
    "data-name": "Rect\\xE1ngulo 130",
    width: 19.695,
    height: 28.136,
    transform: "translate(5.169 6.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(1188.402 530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-2",
    "data-name": "Trazado 60",
    d: "M3.213,0H26.506a3.11,3.11,0,0,1,3.213,3V37.449a3.11,3.11,0,0,1-3.213,3H3.213a3.11,3.11,0,0,1-3.213-3V3A3.11,3.11,0,0,1,3.213,0Z",
    transform: "translate(0 0)",
    fill: "#2c3d71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130-2",
    "data-name": "Rect\\xE1ngulo 130",
    width: 19.695,
    height: 28.136,
    transform: "translate(5.169 6.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    transform: "translate(1188.402 578.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-3",
    "data-name": "Trazado 60",
    d: "M3.213,0H26.506a3.11,3.11,0,0,1,3.213,3V37.449a3.11,3.11,0,0,1-3.213,3H3.213a3.11,3.11,0,0,1-3.213-3V3A3.11,3.11,0,0,1,3.213,0Z",
    transform: "translate(0 0)",
    fill: "#2c3d71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130-3",
    "data-name": "Rect\\xE1ngulo 130",
    width: 19.695,
    height: 28.136,
    transform: "translate(5.169 6.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238",
    transform: "translate(1152.465 578.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-4",
    "data-name": "Trazado 60",
    d: "M3.213,0H26.506a3.11,3.11,0,0,1,3.213,3V37.449a3.11,3.11,0,0,1-3.213,3H3.213a3.11,3.11,0,0,1-3.213-3V3A3.11,3.11,0,0,1,3.213,0Z",
    transform: "translate(0 0)",
    fill: "#2c3d71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130-4",
    "data-name": "Rect\\xE1ngulo 130",
    width: 19.695,
    height: 28.136,
    transform: "translate(5.169 6.168)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountByWorkplace);
export default __webpack_public_path__ + "static/media/countByWorkplace.bafa11e7.svg";
export { ForwardRef as ReactComponent };